import { NgModule, ModuleWithProviders } from '@angular/core';
import { DynamicNgLocaleProvider } from './utils/dynamic-ng-locale';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { featureKey } from './definitions';
import { localeReducer, LOCALE_REDUCER } from './redux/reducers';
import { InitialLocaleLoaderServiceProvider } from './services/initial-locale-loader/initial-locale-loader.service';
import { LocaleResolverServcieProvider } from './services/locale-resolver/locale-resolver.service';
import { LocaleEffects } from './redux/effects';

@NgModule({
  imports: [StoreModule.forFeature(featureKey, LOCALE_REDUCER as any), EffectsModule.forFeature([LocaleEffects])]
})
export class LocaleManagerModule {
  public static forRoot(): ModuleWithProviders<LocaleManagerModule> {
    return {
      ngModule: LocaleManagerModule,
      providers: [
        DynamicNgLocaleProvider,
        LocaleResolverServcieProvider,
        {
          provide: LOCALE_REDUCER,
          useValue: localeReducer
        },
        InitialLocaleLoaderServiceProvider
      ]
    };
  }

  public static forFeature(): ModuleWithProviders<LocaleManagerModule> {
    return {
      ngModule: LocaleManagerModule,
      providers: [
        DynamicNgLocaleProvider,
        LocaleResolverServcieProvider,
        {
          provide: LOCALE_REDUCER,
          useValue: localeReducer
        }
      ]
    };
  }
}
